<template>
  <page-template :pageTitle="pageTitle">
    <template #filter>
      <div class="leftSection">
        <el-button
          size="medium"
          type="success"
          class="createNew"
          @click="isOpenVbBookCreateDialog = true"
        >
          <div class="flex-row flex__center">
            <i class="fas fa-file-plus"></i>
            <span>Thêm mới</span>
          </div>
        </el-button>
      </div>
      <search-template-v2
        :keyword="keyword"
        @simpleSearch="simpleSearch"
        :isDisableAdvanceSearch="true"
      >
      </search-template-v2>
    </template>

    <template #mainContent>
      <div
        class="barChart"
        ref="barChartContainerDiv"
        style="max-height: 100%; overflow: auto"
      >
        <el-table
          :data="listBook"
          class="style-fullWidth"
          highlight-current-row
          sortable="custom"
          @sort-change="doSort"
          @row-click="viewDocInBook"
          :default-sort="convertToTableSortEvent()"
        >
          <el-table-column type="index" fixed></el-table-column>

          <el-table-column
            property="bookName"
            label="Tên sổ"
            min-width="300"
            sortable
            fixed
            :show-overflow-tooltip="true"
          >
          </el-table-column>

          <el-table-column
            property="bookCurrentNumber"
            label="Số sổ hiện tại"
            min-width="150"
            sortable
            :show-overflow-tooltip="true"
            align="right"
          >
          </el-table-column>

          <el-table-column
            property="prefix"
            label="Ký hiệu văn bản"
            min-width="150"
            sortable
            :show-overflow-tooltip="true"
          >
          </el-table-column>

          <el-table-column
            property="vbBookStatus"
            label="Trạng thái"
            min-width="150"
            sortable
            :show-overflow-tooltip="true"
            align="center"
          >
            <template slot-scope="{ row }">
              <common-status-tag :status="row.vbBookStatus"></common-status-tag>
            </template>
          </el-table-column>

          <el-table-column width="150" align="right">
            <template slot-scope="{ row }">
              <el-button
                type="primary"
                icon="el-icon-edit"
                circle
                @click.native="edit(row)"
                @click.native.stop="() => true"
              ></el-button>
              <el-button
                type="danger"
                icon="el-icon-delete"
                circle
                @click="delete_(row)"
                @click.native.stop="() => true"
              ></el-button>
            </template>
          </el-table-column>

          <infinite-loading
            slot="append"
            ref="infiniteLoading"
            spinner="spiral"
            @infinite="infiniteHandler"
            force-use-infinite-wrapper=".el-table__body-wrapper"
          >
            <div slot="no-more"></div>
            <div slot="no-results"></div>
          </infinite-loading>
        </el-table>
      </div>

      <vb-book-create-dialog
        :isOpen="isOpenVbBookCreateDialog"
        :bookType="bookType"
        v-if="isEnableVbBookCreateDialog"
        @closed="isEnableVbBookCreateDialog = false"
        @closeDialog="isOpenVbBookCreateDialog = false"
        @success="createSuccess"
      />
    </template>
  </page-template>
</template>
<script>
import bookService from "../../services/bookService";
import dateFormatter from "../../filters/dateFormatter";
import InfiniteLoading from "vue-infinite-loading";
import constants from "../../constants";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import utils from "../../services/utils";
import handleRequestErrorMixin from "../handleRequestErrorMixin";
import goBackMixin from "../../mixins/goBackMixin";
import PageTemplate from "../common/layout/page-template";
import SearchTemplateV2 from "../common/layout/search-template-v2";
import CommonStatusTag from "../common/common-status-tag";
import VbBookCreateDialog from "./vb-book-create-dialog";

export default {
  name: "vb-book-index-v2",
  mixins: [handleRequestErrorMixin, goBackMixin],
  components: {
    VbBookCreateDialog,
    CommonStatusTag,
    SearchTemplateV2,
    PageTemplate,
    InfiniteLoading,
    VuePerfectScrollbar,
  },

  filters: { dateFormatter },

  data() {
    return {
      keyword: null,
      sort: null,
      order: null,
      page: 0,
      size: 10,
      listBook: [],
      pageTitle: null,

      isOpenVbBookCreateDialog: false,
      isEnableVbBookCreateDialog: false,

      deptCode: null,
      department: null,
      search: "",
      isCreateNew: false,
      isUpdate: false,
    };
  },

  computed: {
    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    },
    bookType() {
      return parseInt(this.$route.params.bookType);
    },
  },

  watch: {
    bookType() {
      this.initComponent();
    },
    isOpenVbBookCreateDialog(newValue) {
      newValue && (this.isEnableVbBookCreateDialog = newValue);
    },
  },

  created() {
    this.registerEventBusForMaster(() => {
      this.doSearch();
    });
    this.initComponent();
  },

  destroyed() {
    this.unregisterEventBusForMaster();
  },

  methods: {
    convertToTableSortEvent() {
      return utils.convertToTableSortEvent({
        sort: this.sort,
        order: this.order,
      });
    },

    initComponent() {
      this.page = 0;
      this.listBook = [];
      this.pageTitle = this.getPageTitle();
      this.initQuery();
      this.doSearch();
    },

    delete_(item) {
      return utils
        .confirm(this.$confirm, `Bạn có chắc muốn xóa sổ "${item.bookName}"?`)
        .then(() => {
          bookService
            .delete(item.id)
            .then(() => {
              this.$message.success("Xóa thành công");
              this.doSearch();
            })
            .catch((error) => this.commonHandleRequestError(error));
        });
    },

    viewDocInBook(item) {
      if (item.bookType === constants.BOOK_TYPE.VB_DI) {
        let params = utils.merge(this.$route.params, {
          userDeptRoleId: this.userDeptRoleId,
        });
        let query = { bookId: item.id };
        this.$router.push({
          name: "vbDiDaVaoSo",
          params: params,
          query: query,
        });
      } else {
        let params = utils.merge(this.$route.params, {
          userDeptRoleId: this.userDeptRoleId,
        });
        let query = { bookId: item.id };
        this.$router.push({ name: "vbDaVaoSo", params: params, query: query });
      }
    },

    edit(item) {
      let query = utils.merge(this.$route.query, {
        bookType: item.bookType,
      });
      let params = utils.merge(this.$route.params, {
        id: item.id,
      });
      this.$router.push({
        name:
          this.bookType === constants.BOOK_TYPE.VB_DEN
            ? "quanlySoDenDetail"
            : "quanlySoDiDetail",
        params: params,
        query: query,
      });
    },

    createSuccess() {
      console.log("createSuccess");
      this.isOpenVbBookCreateDialog = false;
      this.doSearch();
    },

    initQuery() {
      this.keyword = utils.getParamFromQuery(this.$route.query, "keyword");
      this.sort = this.$route.query.sort || "updateTime";
      this.order = this.$route.query.order || "desc";
    },

    convertToSubmitForm() {
      return {
        bookType: this.bookType,
        keyword: this.keyword,
      };
    },

    buildQuery() {
      return {
        keyword: this.keyword || undefined,
        sort: this.sort,
        order: this.order,
      };
    },

    simpleSearch(keyword) {
      this.keyword = keyword;
      this.storeQuery();
      this.doSearch();
    },

    doSort(event) {
      let { order, sort } = utils.convertElTableSortEvent(event);
      this.sort = sort;
      this.order = order;
      this.storeQuery();
      this.doSearch();
    },

    storeQuery() {
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: this.buildQuery(),
      });
    },

    doSearch() {
      this.listBook = [];
      this.page = 0;
      if (this.$refs.infiniteLoading) {
        this.$refs.infiniteLoading.stateChanger.reset();
      }
    },

    infiniteHandler($state) {
      this.list().then((items) => {
        this.page += 1;
        items && items.length ? $state.loaded() : $state.complete();
      });
    },

    list() {
      let pageable = utils.convertToPagable({
        page: this.page,
        size: this.size,
        sort: this.sort,
        order: this.order,
      });

      return bookService
        .findAll(this.convertToSubmitForm(), pageable)
        .then((response) => {
          let items = response.data || [];
          if (items) this.listBook.push(...items);
          return items;
        });
    },

    getPageTitle() {
      switch (this.bookType) {
        case constants.BOOK_TYPE.VB_DEN:
          return "Quản lý sổ đến";
        case constants.BOOK_TYPE.VB_DI:
          return "Quản lý sổ đi";
        default:
          return "";
      }
    },
  },
};
</script>
<style>
/*.book-dialog {*/
/*  border-radius: 6px;*/
/*}*/

/*.text-left {*/
/*  text-align: left;*/
/*}*/

.el-input-number-custom > div > input {
  border: none;
  border-radius: 0px;
  border-bottom: 1px solid #dcdfe6;
  text-align: left !important;
  padding-left: 0 !important;
  font-size: 14px !important;
}

.el-input-number-custom > span {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/book/vb-book-index-v2.vue